// import React from 'react';
// import Sidebar from './Components/Sidebar';

// import { Navigate, useLocation } from 'react-router-dom';

// const AdminRoute = ({ children }) => {
//     const location = useLocation();
//     const isAuthenticated = localStorage.getItem('token');
//     const isAdmin = localStorage.getItem('admin');

//     // Check if the user exists and all the role conditions are true
    
//     if (!isAuthenticated) {
//         // Redirect them to the /login page, but save the current location they were trying to go to
//         return <Navigate to="/login" />;
//     }
//     else if (isAdmin === "false"){
//         return <Navigate to="/manager-dashboard" />;
//     }

//     // Wrap children in the Sidebar component
//     return (
//         <Sidebar>
//             {children}
//         </Sidebar>
//     );
// };

// export default AdminRoute;

import React from 'react';
import Sidebar from './Components/Sidebar';
import { Navigate, useLocation } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const location = useLocation();
    const isAuthenticated = localStorage.getItem('token');
    const isAdmin = localStorage.getItem('admin');
    const isStaff = localStorage.getItem('staff_user'); // Get staff user role

    // Check if the user is authenticated
    if (!isAuthenticated) {
        // Redirect them to the /login page, but save the current location they were trying to go to
        return <Navigate to="/login" />;
    }
    // Check if the user is neither an admin nor a staff
    else if (isAdmin === "false" && isStaff === "false") {
        return <Navigate to="/manager-dashboard" />;
    }

    // Wrap children in the Sidebar component
    return (
        <Sidebar>
            {children}
        </Sidebar>
    );
};

export default AdminRoute;
